// src/components/Reports/ReportDatePicker.tsx
// Shared date picker for Report Viewer widgets — same style as AttendanceReport

import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

interface ReportDateInputProps {
  value?: string;
  onClick?: () => void;
  onClear: () => void;
  clearable?: boolean;
}

const ReportDateInput = React.forwardRef<HTMLInputElement, ReportDateInputProps>(
  ({ value, onClick, onClear, clearable = true }, ref) => (
    <div className="ar-date-input-wrapper">
      <input
        ref={ref}
        type="text"
        value={value || ''}
        onClick={onClick}
        readOnly
        className="ar-date-input"
        placeholder="MM/DD/YYYY"
        onChange={() => {}}
      />
      <button
        type="button"
        className="ar-date-icon-btn"
        onClick={clearable && value ? onClear : onClick}
        tabIndex={-1}
      >
        {clearable && value ? (
          <i className="icon-incorrect-icon" style={{ fontSize: 10 }} />
        ) : (
          <i className="fa fa-calendar" style={{ fontSize: 12 }} />
        )}
      </button>
    </div>
  ),
);
ReportDateInput.displayName = 'ReportDateInput';

interface ReportDatePickerProps {
  /** Value in YYYY-MM-DD format */
  value: string;
  onChange: (isoDate: string) => void;
  label?: string;
  clearable?: boolean;
}

export const ReportDatePicker: React.FC<ReportDatePickerProps> = ({
  value,
  onChange,
  label,
  clearable = true,
}) =>
{
  const parsed = value ? moment(value, 'YYYY-MM-DD', true) : null;
  const selected = parsed?.isValid() ? parsed.toDate() : null;

  return (
    <div className="burndownchart_select" style={{ gap: 4 }}>
      {label && <span className="burndownchart_Label">{label}</span>}
      <DatePicker
        selected={selected}
        onChange={(d: any) => onChange(d ? moment(d).format('YYYY-MM-DD') : '')}
        dateFormat="MM/dd/yyyy"
        customInput={<ReportDateInput onClear={() => onChange('')} clearable={clearable} />}
        popperProps={{ strategy: 'fixed' }}
        showPopperArrow={false}
        // Portal to body so the popper escapes transformed ancestors (e.g. Modal).
        portalId="report-datepicker-portal"
        calendarClassName="ar-datepicker-calendar"
      />
    </div>
  );
};
